import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Row, Icon, Typography, Popconfirm } from 'antd'
const { Paragraph } = Typography
import { drugs } from '@services/api'

@inject((store: any) => {
    const { popupStore, authStore, drugsStore } = store
    return { popupStore, authStore, drugsStore }
})
@observer
export default class extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            value: ''
        }
        this.handleSave = this.handleSave.bind(this)
        this.closePopup = this.closePopup.bind(this)
    }

    async handleSave() {
        let {
            authStore: { fullName },
            drugsStore: { getDrugs }
        } = this.props
        const { value } = this.state
        if (value.length) {
            await drugs.addFamily({ name: value, updated_by: fullName })
            getDrugs()
        } else {
            alert('אין לשמור משפחה ללא שם')
        }
    }

    closePopup() {
        this.props.popupStore.togglePopup(false)
        this.setState({ value: '' })
    }

    render() {
        const {
            popupStore: { popupType },
            drugsStore: { families }
        } = this.props
        const footerButtons = (
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )
        let rowStyle = {
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            borderBottom: 'solid',
            borderBottomColor: 'black',
            borderBottomWidth: 1
        }

        let marginRight = { marginRight: 75 }
        return (
            <Modal
                title={`הוסף או הסר משפחה`}
                visible={popupType === 'handleDrugFamilies'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
                width={1200}
            >
                <Row gutter={28} style={rowStyle}>
                    <input
                        value={this.state.value}
                        onChange={e => this.setState({ value: e.target.value })}
                        style={{ width: 800 }}
                    />
                    <Icon type="check" style={marginRight} onClick={this.handleSave} />
                </Row>
                {families
                    .filter(family => !!family.updated_by)
                    .map(family => (
                        <Row key={family.id} gutter={28} style={{ ...rowStyle }}>
                            <Paragraph>{family.name}</Paragraph>
                            <Popconfirm
                                placement="topLeft"
                                title={'האם ברצונך להסיר את המשפחה?'}
                                onConfirm={async () => {
                                    await drugs.dltFamily(family.id)
                                    this.props.drugsStore.getDrugs()
                                }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Icon type="delete" onClick={() => {}} />
                            </Popconfirm>
                        </Row>
                    ))}
            </Modal>
        )
    }
}
